export function wakeCodeAnalyzer(): void {
  wakeUp(process.env.NEXT_PUBLIC_CODE_ANALYZER_URL);
}

/** Wakes the judge service the problem's requests go to (see `needsExclusiveJudge`). */
export function wakeUpJudge(needsExclusiveJudge: boolean): void {
  wakeUp(needsExclusiveJudge ? process.env.NEXT_PUBLIC_JUDGE_EXCLUSIVE_URL : process.env.NEXT_PUBLIC_JUDGE_URL);
}

export function wakeUpMotiAI(): void {
  wakeUp(process.env.NEXT_PUBLIC_MOTI_AI_URL);
}

function wakeUp(url: string | undefined): void {
  const baseUrl = tryParseOrigin(url);
  if (baseUrl === undefined) return;

  void fetch(baseUrl, { cache: 'no-store' }).catch(() => {
    /* do nothing. */
  });
}

function tryParseOrigin(url: string | undefined): string | undefined {
  if (!url) return undefined;

  try {
    return new URL(url).origin;
  } catch {
    return undefined;
  }
}
